import { render, staticRenderFns } from "./ManageMedia.vue?vue&type=template&id=0edc26ce&"
import script from "./ManageMedia.vue?vue&type=script&lang=js&"
export * from "./ManageMedia.vue?vue&type=script&lang=js&"
import style0 from "./ManageMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports